import { CommonModule } from '@angular/common';
import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { InitUserService } from './@theme/services/init-user.service';
import { VersionCheckService } from './@theme/services/version-check.service';
import { MiddlemanService } from './auth/services/Middleman.service';
import { ThemeService } from './auth/services/theme.service';

@Component({
    selector: 'app-root',
    imports: [
        CommonModule,
        RouterOutlet,
        FormsModule,
        ReactiveFormsModule,
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  @HostBinding('class') hostClass = 'flex grow';
  title = 'UV-Connects';
  isRoleSwitching = false;
  private subscription = new Subscription();
  
constructor(
  private themeService: ThemeService,
  private middlemanService: MiddlemanService,
  private versionCheckService: VersionCheckService
) {
  
}
init_app(initUserService: InitUserService) {
  return () =>
    new Promise<void>((resolve, reject) => {
      initUserService.initCurrentUser().subscribe({
        next: () => resolve(),
        error: (err) => reject(err)
      });
    });
}
ngOnInit() {
  this.themeService.initThemeListener();
  this.versionCheckService.start();

  // Subscribe to role switching state
  this.subscription.add(
    this.middlemanService.roleSwitching$.subscribe(switching => {
      this.isRoleSwitching = switching;
    })
  );
/*    const initializerFn = (this.init_app);
   return initializerFn; */
}

ngOnDestroy() {
  this.subscription.unsubscribe();
}
}
